// Calculate progress value based on current index and total fields
// Starts at 5% and ends at 100%
export const calculateProgress = (index: number, total: number): number => {
  if (total <= 1) return 100; // If only one field, show 100%
  return 5 + (index / (total - 1)) * 95;
};
